import { useStaticQuery, graphql } from "gatsby"

export default function useLayersImages() {
  return useStaticQuery(graphql`
    query {
      layersSvgLg: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools/Desktop/platform_infographic_desktop.svg"
        }
      ) {
        publicURL
      }
      layersSvgMd: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools/Desktop/platform_infographic_tablet.svg"
        }
      ) {
        publicURL
      }
      iconLayer1: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools/Mobile/layer_1_icon.svg"
        }
      ) {
        publicURL
      }
      iconLayer2: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools/Mobile/layer_2_icon.svg"
        }
      ) {
        publicURL
      }
    }
  `)
}
